import { AntSelect } from './select.style';

const AntTreeSelect = (component) => AntSelect(component);

export { AntTreeSelect };
